export default __webpack_public_path__ + "static/media/ConstP.2280288b.png";